var map = {
	"./3QuirkyNostalgicSocialMediaGames.webp": "yvmK",
	"./5NarrativePixelArtGamesDemos.webp": "+/gI",
	"./5StoryRichIndieGamesCuteFroggyProtagonists.webp": "4ox3",
	"./7BeautifulIndieGames.webp": "pU8Q",
	"./7eyecatchingindiegamesPYG.webp": "6KaX",
	"./9HeartwarmingGames.webp": "zh4B",
	"./AngelaHe.webp": "cWxs",
	"./AviaryAttorney.webp": "UUuN",
	"./CardOfDarkness.webp": "l9Bh",
	"./Carto.webp": "o8Yu",
	"./Chicory.webp": "Plpn",
	"./CoffeeTalk.webp": "1k74",
	"./DarksideDetective.webp": "j5Xp",
	"./DetectiveGui.webp": "HZc8",
	"./DifficultyDifficultGames.webp": "HUki",
	"./DontOpenYourEyes.webp": "Cr4K",
	"./Eliza.webp": "ljTt",
	"./EmilyIsAway.webp": "mvhw",
	"./EverForward.webp": "+9ra",
	"./Firewatch.webp": "y0ZL",
	"./ForTheKing.webp": "H0+1",
	"./ForThePeople.webp": "aTgr",
	"./Forager.webp": "udGN",
	"./Frogsong.webp": "zgQ2",
	"./IndieArenaBooth.webp": "6DNI",
	"./Lamentum.webp": "2tv/",
	"./LucasPope.webp": "SRo0",
	"./MinuteOfIslands.webp": "jcMY",
	"./Moonlighter.webp": "nGwm",
	"./Nanopesos.webp": "WFVH",
	"./NightInTheWoods.webp": "vwZA",
	"./OldMansJourney.webp": "6j2r",
	"./RiskOfRain.webp": "QxX+",
	"./Rosewater.webp": "fJ2N",
	"./SortTheCourt.webp": "s4tg",
	"./Syberia.webp": "zgAL",
	"./Symphonia.webp": "hVQz",
	"./TakeshiAndHiroshi.webp": "K1Hr",
	"./TangleTower.webp": "aP/8",
	"./TownOfLight.webp": "Ydd2",
	"./UnboundWorldsApart.webp": "F+Jo",
	"./Underdown.webp": "/vii",
	"./Venice2089.webp": "B3bK",
	"./Verne.webp": "c/CQ",
	"./WelcomeToElk.webp": "akjl",
	"./WhenThePastWasAround.webp": "ERjs",
	"./WhenThePastWasAroundFull.webp": "FnMC",
	"./WindingWorlds.webp": "P+FA",
	"./cateau.webp": "jHie",
	"./gamepad.png": "xhRE",
	"./gamepad.webp": "VopH",
	"./isg-banner.png": "HAMZ",
	"./nightofrabbit.webp": "Zxnm",
	"./npckc.webp": "kc47",
	"./small/3QuirkyNostalgicSocialMediaGames.webp": "BAx9",
	"./small/5NarrativePixelArtGamesDemos.webp": "4a2c",
	"./small/5StoryRichIndieGamesCuteFroggyProtagonists.webp": "Tqd9",
	"./small/7BeautifulIndieGames.webp": "/DRN",
	"./small/7eyecatchingindiegamesPYG.webp": "E/uE",
	"./small/9HeartwarmingGames.webp": "s5P0",
	"./small/AngelaHe.webp": "uvhZ",
	"./small/AviaryAttorney.webp": "KKcs",
	"./small/CardOfDarkness.webp": "qhee",
	"./small/Carto.webp": "paZM",
	"./small/Chicory.webp": "muJZ",
	"./small/CoffeeTalk.webp": "A8yU",
	"./small/DarksideDetective.webp": "wJ6M",
	"./small/DetectiveGui.webp": "kid+",
	"./small/DifficultyDifficultGames.webp": "7gH0",
	"./small/DontOpenYourEyes.webp": "QXs/",
	"./small/Eliza.webp": "LAaY",
	"./small/EmilyIsAway.webp": "/F2l",
	"./small/EverForward.webp": "jg6t",
	"./small/Firewatch.webp": "1Z8q",
	"./small/ForTheKing.webp": "Ejcr",
	"./small/ForThePeople.webp": "GLxA",
	"./small/Forager.webp": "BscX",
	"./small/Frogsong.webp": "doqG",
	"./small/IndieArenaBooth.webp": "Z+02",
	"./small/Lamentum.webp": "+os9",
	"./small/LucasPope.webp": "BXLd",
	"./small/MinuteOfIslands.png": "RkOE",
	"./small/MinuteOfIslands.webp": "nZB4",
	"./small/Moonlighter.webp": "RMJI",
	"./small/Nanopesos.webp": "T7u0",
	"./small/NightInTheWoods.webp": "qwut",
	"./small/OldMansJourney.webp": "WYLj",
	"./small/RiskOfRain.webp": "E14s",
	"./small/Rosewater.webp": "2h+Z",
	"./small/SortTheCourt.webp": "9P+K",
	"./small/Syberia.webp": "lV0p",
	"./small/Symphonia.webp": "1O08",
	"./small/TakeshiAndHiroshi.webp": "q5a7",
	"./small/TangleTower.webp": "ilbr",
	"./small/TownOfLight.webp": "2AcX",
	"./small/UnboundWorldsApart.webp": "gY0t",
	"./small/Underdown.webp": "PBRj",
	"./small/Venice2089.webp": "BDxx",
	"./small/Verne.webp": "oYxI",
	"./small/WelcomeToElk.webp": "boA9",
	"./small/WhenThePastWasAround.webp": "G9nR",
	"./small/WhenThePastWasAroundFull.webp": "W0OY",
	"./small/WindingWorlds.webp": "Kmox",
	"./small/cateau.webp": "+oGp",
	"./small/nightofrabbit.webp": "5u7n",
	"./small/npckc.webp": "5qPm",
	"./small/tacoma.webp": "tI+a",
	"./tacoma.webp": "vKN4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5YDF";